"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createParametrizedUrl;
function createParametrizedUrl(url, params) {
  Object.keys(params).forEach(function (key) {
    return url = url.replace("{".concat(key, "}"), params[key]);
  });
  return url;
}